import React, { useState, useRef } from "react";

/* Accordion row shared by the landing and pricing pages (styles in
   LandingPage.css under .lp-faq). */
const FaqItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  const bodyRef = useRef(null);

  return (
    <div className={`lp-faq__item${open ? " is-open" : ""}`} data-reveal>
      <button className="lp-faq__q" onClick={() => setOpen(!open)} aria-expanded={open}>
        <span>{question}</span>
        <span className="lp-faq__sign" aria-hidden="true">
          <i /><i />
        </span>
      </button>
      <div
        className="lp-faq__a"
        ref={bodyRef}
        style={{ maxHeight: open ? `${bodyRef.current?.scrollHeight || 300}px` : 0 }}
      >
        <p>{answer}</p>
      </div>
    </div>
  );
};

export default FaqItem;
